import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HouseFlatService } from '../../../services/house-flat.service';

@Component({
  selector: 'app-house-flat-payments-page',
  templateUrl: './house-flat-payments-page.component.html',
  styleUrl: './house-flat-payments-page.component.scss'
})
export class HouseFlatPaymentsPageComponent implements OnInit {

  public loading = true;
  public data: any;
  public houseFlat: any;
  public neighborhoodId = '';
  public streetBuildingId = '';
  public houseFlatId = '';
  public activeTab = 1;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private houseFlatService: HouseFlatService,
  ) {}

  /*
  ███╗   ██╗ ██████╗ ██╗███╗   ██╗██╗████████╗
  ████╗  ██║██╔════╝ ██║████╗  ██║██║╚══██╔══╝
  ██╔██╗ ██║██║  ███╗██║██╔██╗ ██║██║   ██║
  ██║╚██╗██║██║   ██║██║██║╚██╗██║██║   ██║
  ██║ ╚████║╚██████╔╝██║██║ ╚████║██║   ██║
  ╚═╝  ╚═══╝ ╚═════╝ ╚═╝╚═╝  ╚═══╝╚═╝   ╚═╝

  */
  // region ngOnInit
  async ngOnInit() {
    this.neighborhoodId = this.route.snapshot.params['neighborhoodId'];
    this.streetBuildingId = this.route.snapshot.params['streetBuildingId'];
    this.houseFlatId = this.route.snapshot.params['houseFlatId'];
    await this.loadData();
  }

  /*
  ██╗      ██████╗  █████╗ ██████╗ ██████╗  █████╗ ████████╗ █████╗
  ██║     ██╔═══██╗██╔══██╗██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  ██║     ██║   ██║███████║██║  ██║██║  ██║███████║   ██║   ███████║
  ██║     ██║   ██║██╔══██║██║  ██║██║  ██║██╔══██║   ██║   ██╔══██║
  ███████╗╚██████╔╝██║  ██║██████╔╝██████╔╝██║  ██║   ██║   ██║  ██║
  ╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝

  */
  // region loadData
  async loadData() {
    this.loading = true;
    const response = await this.houseFlatService.getPayments(
      this.neighborhoodId,
      this.streetBuildingId,
      this.houseFlatId
    );
    if (response) {
      this.data = response;
    }
    this.loading = false;
  }

  /*
   ██████╗  ██████╗     ██████╗  █████╗  ██████╗██╗  ██╗
  ██╔════╝ ██╔═══██╗    ██╔══██╗██╔══██╗██╔════╝██║ ██╔╝
  ██║  ███╗██║   ██║    ██████╔╝███████║██║     █████╔╝
  ██║   ██║██║   ██║    ██╔══██╗██╔══██║██║     ██╔═██╗
  ╚██████╔╝╚██████╔╝    ██████╔╝██║  ██║╚██████╗██║  ██╗
   ╚═════╝  ╚═════╝     ╚═════╝ ╚═╝  ╚═╝ ╚═════╝╚═╝  ╚═╝

  */
  // region goBack
  goBack() {
    this.router.navigate([
      '/neighborhoods',
      this.neighborhoodId,
      'streets-buildings',
    ]);
  }


}
